import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useAuth } from "../../context/AuthProvider";
import {
  initAnalytics,
  setAnalyticsUser,
  clearAnalyticsUser,
  trackPageView,
} from "../../services/analytics";

/**
 * Renders nothing. Loads Google Analytics (gtag.js) using the runtime
 * measurement ID from window.config, and keeps the analytics user in
 * sync with the Okta auth state: on login the user's email/name are
 * attached to all subsequent analytics calls, on logout they're cleared.
 *
 * Also sends a page_view on every React Router navigation (SPA route
 * changes don't reload the page, so GA wouldn't see them otherwise).
 *
 * Must be mounted inside <AuthProvider> and <BrowserRouter>.
 */
const GoogleAnalytics = () => {
  const { authState } = useAuth();
  const location = useLocation();

  useEffect(() => {
    const userId = authState.user?.sub || null;
    initAnalytics(userId);
  }, [authState.user?.sub]);

  // Page views: fires for the initial route and every navigation.
  useEffect(() => {
    trackPageView(location.pathname + location.search);
  }, [location.pathname, location.search]);

  useEffect(() => {
    if (authState.isLoading) return;

    if (authState.isAuthenticated) {
      const email =
        authState.user?.email || localStorage.getItem("userEmail") || null;
      const name = authState.user?.name || null;
      const userId = authState.user?.sub || null;
      setAnalyticsUser({ userId, email, name });
    } else {
      clearAnalyticsUser();
    }
  }, [authState.isAuthenticated, authState.isLoading, authState.user]);

  return null;
};

export default GoogleAnalytics;
